import { shareLiveLocations as mutation } from "../../lib/graphql";
import { setLoaderStart, setLoaderComplete } from "../loader/loader";
import showToaster from "../../helpers/toastrMessgaes/showToaster";

// SOS: share the client's live job location with their emergency contacts (parity with the app).
// The web resolver bridges to besthand-api which sends the SMS.
export function shareLiveLocationAction({ bookingId, currentLocation }) {
    return async (dispatch, getState, { client }) => {
        try {
            if (typeof navigator !== 'undefined' && !navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' });
                return false;
            }
            dispatch(setLoaderStart('shareLiveLocation'));

            const { data } = await client.mutate({
                mutation,
                variables: { bookingId: Number(bookingId), currentLocation },
                fetchPolicy: 'no-cache',
            });

            dispatch(setLoaderComplete('shareLiveLocation'));

            if (data?.shareLiveLocations?.status === 200) {
                await showToaster({ messageId: 'shareLocationSuccess', toasterType: 'success' });
                return true;
            }
            await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: { content: data?.shareLiveLocations?.errorMessage } });
            return false;
        } catch (error) {
            dispatch(setLoaderComplete('shareLiveLocation'));
            await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: { content: error?.message } });
            return false;
        }
    };
}
